<template>
  <td>
    <div v-if="showNullHtml" v-html="nullHtml"></div>
    <div v-else>
      {{ source.name }}
    </div>
  </td>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";

export default {
    props: ['model', 'content'],
    computed: {
      source () {
        if(this.content !== ''){
          return this.content;
        }
        return this.model;
      },
      showNullHtml() {
        return !this.source;
      },
      nullHtml() {
        return defaultNullHtml();
      },
    }
};
</script>
